import React from 'react'
import { useI18n } from '../i18n/I18nContext'

function AlertSuccess({setAlertSuccess}) {
    const { t } = useI18n();
    return (
        <div className="absolute flex items-center justify-center w-full h-screen top-0 overflow-hidden p-7 bg-[#444444e6]">
            <div className="w-1/3 p-12  bg-white rounded-lg text-center border">
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
                <h3 className='text-3xl font-semibold'>{t('alert.success.title')}</h3>
                <p className='font-semibold text-lg text-green-500  mb-6'>{t('alert.success.msg')}</p>
                <button onClick={() => setAlertSuccess(false)} className='rounded text-white bg-sky-600 py-2 px-4'>{t('common.ok')}</button>
            </div>
        </div>
    )
}

export default AlertSuccess
